import { TEventData } from "~/types";
import axiosInstance from "./client";

export const getEventList = async (walletId: string): Promise<TEventData[]> => {
  let ret = [];
  const response = await axiosInstance.get(
    `/event/all?walletInforID=${walletId}`
  );

  const events = response.data;

  ret = events?.map((event: any) => ({ eventId: event.eventID, ...event }));

  return ret;
};
